import React, {useEffect, useRef} from "react";
import {Animated, Easing} from "react-native";
import Svg, {Defs, LinearGradient, Stop, Rect, ClipPath, G} from "react-native-svg";

const AnimatedRect = Animated.createAnimatedComponent(Rect);

/**
 * 로딩 스피너 — accent 하이라이트가 알약(pill) 위를 좌→우로 훑는 shimmer.
 * 옅은 accent 베이스 + 그라데이션 하이라이트가 이동. borderRadius/좌표 애니 → useNativeDriver:false.
 */
export default function Shimmer({color, width = 58, height = 10}: {color: string; width?: number; height?: number}) {
    const x = useRef(new Animated.Value(-width)).current;

    useEffect(() => {
        const loop = Animated.loop(Animated.timing(x, {
            toValue: width, duration: 1200, easing: Easing.linear, useNativeDriver: false,
        }));
        loop.start();
        return () => loop.stop();
    }, []);

    return (
        <Svg width={width} height={height}>
            <Defs>
                <LinearGradient id="shg" x1="0" y1="0" x2="1" y2="0">
                    <Stop offset="0" stopColor={color} stopOpacity="0"/>
                    <Stop offset="0.5" stopColor={color} stopOpacity="1"/>
                    <Stop offset="1" stopColor={color} stopOpacity="0"/>
                </LinearGradient>
                <ClipPath id="shpill">
                    <Rect x="0" y="0" width={width} height={height} rx={height / 2}/>
                </ClipPath>
            </Defs>
            <G clipPath="url(#shpill)">
                <Rect x="0" y="0" width={width} height={height} fill={color} opacity={0.16}/>
                <AnimatedRect y="0" width={width} height={height} fill="url(#shg)" x={x}/>
            </G>
        </Svg>
    );
}
